import { fetchBaseQuery } from '@reduxjs/toolkit/query';

import type { RootState } from '.';

const baseApiQuery = fetchBaseQuery({
  baseUrl: `${process.env.NEXT_PUBLIC_API_URL}/api`,
  prepareHeaders: (headers, { getState }) => {
    const { token } = (getState() as RootState).auth;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
  fetchFn: async (input, init) => {
    // * Simulate slow API response
    if (process.env.NEXT_PUBLIC_DEV_MODE && sessionStorage.getItem('devTools-api-wait-time')) {
      await new Promise((resolve) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        setTimeout(resolve, Number(sessionStorage.getItem('devTools-api-wait-time') as `${number}`) * 1000);
      });
    }

    const response = await fetch(input, init);

    if (response.status === 401) {
      window.location.reload();

      throw new Error('Unauthorized');
    }

    return response;
  },
});

export default baseApiQuery;
